import { render, staticRenderFns } from "./VarFormSetting.vue?vue&type=template&id=7743c852"
import script from "./VarFormSetting.vue?vue&type=script&lang=js"
export * from "./VarFormSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7743c852')) {
      api.createRecord('7743c852', component.options)
    } else {
      api.reload('7743c852', component.options)
    }
    module.hot.accept("./VarFormSetting.vue?vue&type=template&id=7743c852", function () {
      api.rerender('7743c852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/SettingPages/VarFormSetting.vue"
export default component.exports